import { ReactNode } from 'react';

/** Card title of the SMS Credits page: a brand-colored outline icon before the text (one icon family, one size). */
export const SmsCreditsSectionTitle: React.FC<{ icon: ReactNode; children: ReactNode }> = ({
    icon,
    children,
}) => (
    <span className="sms-credits-section-title">
        <span className="sms-credits-section-icon" aria-hidden="true">
            {icon}
        </span>
        {children}
    </span>
);
